export default {
    'h1-bestellingen' : {
        'en' : 'Orders',
        'nl' : 'Bestellingen',
    }
};